import Vue from 'vue';
import Vuex from 'vuex';

import globals from 'globals';

import ExtensionStateStore from 'common/store/extension-state';
import VueMuxy from 'shared/js/muxy-plugin';

import PollsStore from 'shared/js/store/poll';

import App from './App.vue';

Vue.use(VueMuxy, {
  client_id: globals.EXTENSION_ID
});

Vue.use(Vuex);
const store = new Vuex.Store({});
store.registerModule('extension_state', ExtensionStateStore);
store.registerModule('polls', PollsStore);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
